import React, { useEffect, useRef, useState } from "react";
import styles from "./LuckyPage.module.scss";
import LuckyWheel from "./components/LuckyWheel";
import BaleFestivalLogo from "./components/BaleLogo";
import prizeBox from "./lottie/prizeBox.json";
import Lottie from "lottie-react";
import { strings } from "intl/fa";
import { GetWheelStateThunk } from "core/luckyWheel/luckyWheel.thunk";
import { useRequest } from "hooks/useRequest";
import { selectFestivalState } from "core/luckyWheel/luckyWheel.selector";
import { useSelector } from "react-redux";
import { PrizeType, PrizeTypeToText, WheelState } from "core/luckyWheel/luckyWheel.api";
import { Navigate, useNavigate } from "react-router-dom";

const LuckyPage = () => {
  useRequest(GetWheelStateThunk, true);
  const [showPrize, setShowPrize] = useState(false);
  const [prize, setPrize] = useState<PrizeType | undefined>(undefined);
  const explosionSoundEffect = useRef(new Audio("/LuckyWheel/explosion.mp3"));
  const drumRollSoundEffect = useRef(new Audio("/LuckyWheel/drumRoll.mp3"));
  const festivalState = useSelector(selectFestivalState);

  const handleEnd = (prize: number) => {
    setShowPrize(true);
    drumRollSoundEffect.current.volume = 0.5;
    drumRollSoundEffect.current.play();

    setTimeout(() => {
      drumRollSoundEffect.current.pause();
      explosionSoundEffect.current.volume = 0.5;
      explosionSoundEffect.current.play();
      setTimeout(() => {
        explosionSoundEffect.current.pause();
        explosionSoundEffect.current.currentTime = 0;
      }, 3000);
    }, 3000);

    setTimeout(() => {
      setPrize(prize);
    }, 3000);

    if (prize !== PrizeType.PrizeTypeEmpty) {
      setTimeout(() => {
        const winSoundEffect = new Audio("/LuckyWheel/win.mp3");
        winSoundEffect.volume = 0.5;
        winSoundEffect.play();
        setTimeout(() => {
          winSoundEffect.pause();
          winSoundEffect.currentTime = 0;
        }, 3000);
      }, 3000);
    } else {
      setTimeout(() => {
        const looseSoundEffect = new Audio("/LuckyWheel/loose.mp3");
        looseSoundEffect.volume = 0.5;
        looseSoundEffect.play();
      }, 3000);
    }
  };

  if (festivalState === WheelState.INACTIVE) {
    return <Navigate to={"/home"} />;
  }

  return (
    <div className={styles.luckyWheel}>
      {!showPrize && <LuckyWheel onEnd={handleEnd} />}
      <div className={styles.info}>
        <BaleFestivalLogo />
      </div>
      {showPrize && (
        <Lottie animationData={prizeBox} loop={false} autoplay={true} className={styles.prizeBox} />
      )}

      {prize !== undefined && (
        <div className={styles.PrizeText} dir="rtl">
          <div className={styles.Title}>
            {Array.isArray(PrizeTypeToText[prize]) ? (
              (PrizeTypeToText[prize] as string[]).map((text, index) => <p key={index}>{text}</p>)
            ) : (
              <p>{PrizeTypeToText[prize]}</p>
            )}
          </div>
          {prize !== PrizeType.PrizeTypeEmpty && (
            <p className={styles.helpText}>{strings.festival.luckyWheel.prizeFixedText}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default LuckyPage;
